import React from 'react';

const AddProject = () => {
  return (
    <div className='d-block mx-auto mt-5'>
      <h2 className='text-warning'>Please add Project</h2>
    </div>
  );
};

export default AddProject;